import { ConvexReactClient } from 'convex/react';
import { env } from '@/env';

const convex = new ConvexReactClient(env.VITE_CONVEX_URL);

export { convex };
